export const isMobileQuery = {
    query: '(max-width: 640px)'
}


export const webDevSelectValues = [
	{
		label: 'Website Design & Development',
		value: 'Website Design & Development',
	},
	{
		label: 'Custom Software Solutions',
		value: 'Custom Software Solutions',
	},
	{
		label: 'E-Commerce Websites',
		value: 'E-Commerce Websites',
	},
	{
		label: 'App Development',
		value: 'App Development',
	},
]

export const selectValues = [
	{
		label: 'Database Migration',
		value: 'Database Migration',
	},
	{
		label: 'BI Analytics',
		value: 'BI Analytics',
	},
	{
		label: 'Cloud Management',
		value: 'Cloud Management',
	},
	{
		label: 'Cloud Migration',
		value: 'Cloud Migration',
	},
	{
		label: 'Cloud Consultation',
		value: 'Cloud Consultation',
	},
]

export const defaultFormState = {
	name: '',
	email: '',
	phone: '',
	org: '',
	interest: '',
	message: '',
}

// const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/

export const requiredText = (fieldName) => `${fieldName ? fieldName : 'This field'} is required`

export const handleDownloadStaticFile = ({
	path,
	name
}) => {
	if (!path || !name) return 

	const url = path;
	
	const link = document.createElement('a');
	link.href = url;
	link.target = "_blank";
	link.download = name; // This specifies the filename of the downloaded PDF
	
	document.body.appendChild(link);
	
	link.click();
	
	document.body.removeChild(link);
};

function getOrdinalSuffix(day) {
  const j = day % 10;
  const k = day % 100;
  if (j === 1 && k !== 11) {
    return 'st';
  }
  if (j === 2 && k !== 12) {
    return 'nd';
  }
  if (j === 3 && k !== 13) {
    return 'rd';
  }
  return 'th';
}


// Function to get date with ordinal suffix
export function formatDateWithOrdinal(date) {
  const day = date.date();
  const month = date.format('MMMM'); // Full month name
  const year = date.year();

  // Determine the ordinal suffix
  const suffix = getOrdinalSuffix(day);

  return `${day}<sup>${suffix}</sup> ${month}, ${year}`;
}

export const dialogSx = {
  '& .MuiTypography-root.MuiDialogTitle-root': {
    fontFamily: '"Quicksand", sans-serif',
    fontWeight: '600',
    zIndex: 111
  },
  '& .MuiDialogActions-root' : {
    zIndex: 1100
  },
  '@media(max-width: 500px)': {
    'input': {
      fontSize: '0.8rem'
    },
    '& .MuiPaper-root.MuiDialog-paper': {
      minWidth: '90vw'
    },
    '& .MuiInputBase-root': {
      fontSize: '0.8rem'
    },
    '& .MuiDialogTitle-root': {
      position: 'sticky',
      top: 0,
      backgroundColor: '#fff',
      borderBottom: '1px solid lightgrey'
    },
    '& .MuiDialogActions-root': {
      position: 'sticky',
      bottom: 0,
      backgroundColor: '#fff',
      borderTop: '1px solid lightgrey'
    },
  }
}
